import { useConfig } from "../providers/config_provider";
import {
  AnalyticsEvent,
  type SearchResultsGeneratedProperties,
  type SearchResultsClickedProperties,
  type SearchAbandonedProperties,
  track,
} from "../analytics/track";
import {
  updateSearchInteractionId,
  clearSearchInteractionId,
  setSearchInteractionSuccessful,
} from "../analytics/interactions";
import { useMemo } from "react";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Hook

export function useAnalytics() {
  const { organization, excludeFromAnalytics } = useConfig();

  return useMemo(() => {
    function $track(event: AnalyticsEvent.SEARCH_INITIALIZED): void;
    function $track(event: AnalyticsEvent.SEARCH_WIDGET_CLICKED): void;
    function $track(event: AnalyticsEvent.SEARCH_RESULTS_GENERATED, properties: SearchResultsGeneratedProperties): void;
    function $track(event: AnalyticsEvent.SEARCH_RESULTS_CLICKED, properties: SearchResultsClickedProperties): void;
    function $track(event: AnalyticsEvent.SEARCH_ABANDONED, properties: SearchAbandonedProperties): void;
    function $track(event: AnalyticsEvent, properties: Record<string, unknown> = {}) {
      if (excludeFromAnalytics) {
        // Don't track events for super admin IPs
        return;
      }

      if (event === AnalyticsEvent.SEARCH_RESULTS_CLICKED) {
        // Mark this interaction as successful if anything was clicked
        setSearchInteractionSuccessful();
      }

      // Track the event
      track(event, organization, properties);
    }

    return {
      track: $track,
      updateSearchInteractionId,
      clearSearchInteractionId,
    };
  }, [organization, excludeFromAnalytics]);
}
